<template>
  <Walkthrough 
    roomName="Ufficio"
    roomKey="office"
    :steps="steps"
    :backgroundImage="backgroundImage"
    language="italian"
  />
</template>
<script>

export default {
  name: 'Oficina',
  props: ["roomName"],
  data() {
    return {
      backgroundImage: "https://d37bvzh6941o03.cloudfront.net/EscapeTheRoom/images/backgrounds/office-1920x1280.jpg",
      steps: [
        "Guarda a sinistra, poi guarda la scrivania.",
        "Ora che sai che c'è una lettera sulla scrivania, guarda la lettera.",
        "La lettera contiene indizi per il contatore. Nota i quattro oggetti della stanza menzionati nella lettera, e l'ordine in cui compaiono. Poi guarda questi oggetti nella stanza e identifica i colori.",
        "Ora che sai i quattro colori, guarda a destra e ispeziona il contatore. Ora puoi inserire i colori verde, rosso, blu, bianco e dovrebbe tornare la luce nella stanza. Questo ti sarà utile più tardi.",
        "Ora guarda sotto e ispeziona la botola. Dovresti trovare un piede di porco dentro.",
        "Ora che hai il piede di porco, guarda la scrivania a sinistra e usa il piede di porco sul cassetto. Dovresti trovare un cacciavite.",
        "Ora che hai il cacciavite, puoi guardare su e utilizzare il cacciavite sul condotto. Dentro dovresti trovare un martello.",
        "Con il martello che ora hai, puoi guardare a sinistra e utilizzare il martello per rompere la spessa cornice di vetro attorno alla foto. Ciò dovrebbe rivelare un messaggio sul retro.",
        "Utilizzando il messaggio che hai trovato sul retro della foto, dovresti essere riuscire a trovare l'età della figlia (5 anni), e la data della foto (1995) per utilizzare come password per la cassaforte, 0390 (Il compleanno della figlia, Marzo 1990)",
        "Ora guarda a destra e ispeziona la cassaforte. Devi inserire il codice 0390 nella cassaforte e troverai la chiave finale!",
        "Utilizzando la chiave puoi ora guardare davanti, utilizzare la chiave sulla porta, e scappare verso la libertà. Congratulazioni, sei scappato. Prova a completare la prossima stanza da solo!"
      ]
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/walkthrough/it/office.vue